"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bodyScrollLock = require("body-scroll-lock");

var _usePrevious = _interopRequireDefault(require("@hooks/usePrevious"));

var _Portal = require("@components/Portal");

var _scss = require("@scss");

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

var _excluded = ["children", "header", "footer", "classes", "size", "onToggle"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Modal = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$header = _ref.header,
      header = _ref$header === void 0 ? null : _ref$header,
      _ref$footer = _ref.footer,
      footer = _ref$footer === void 0 ? null : _ref$footer,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {
    wrapper: '',
    closeButton: '',
    content: '',
    body: '',
    dialog: '',
    header: '',
    footer: '',
    show: ''
  } : _ref$classes,
      size = _ref.size,
      onToggle = _ref.onToggle,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      preShow = _useState2[0],
      setPreShow = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      show = _useState4[0],
      setShow = _useState4[1];

  var allowClose = (0, _react.useRef)(true);
  var modalsOpen = (0, _react.useRef)(0);
  var modalRef = (0, _react.useRef)(null);
  var prevShow = (0, _usePrevious["default"])(show);
  var prevPreShow = (0, _usePrevious["default"])(preShow);
  var toggle = (0, _react.useCallback)(function () {
    if (!allowClose.current) {
      allowClose.current = true;
      return;
    }

    if (!show) {
      setPreShow(true);
      setTimeout(function () {
        setShow(true);
      }, 250);
    } else {
      setShow(false);
      setTimeout(function () {
        setPreShow(false);
      }, 250);
    }
  }, [show]);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      toggle: toggle,
      show: show,
      preShow: preShow
    };
  }, [preShow, show, toggle]);
  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      if (preShow && !prevPreShow) {
        window.document.body.setAttribute('data-modal-open', 'true');
        return;
      }

      if (!preShow && prevPreShow && !modalsOpen.current) {
        window.document.body.removeAttribute('data-modal-open');
        return;
      }
    }

    if (show !== prevShow) {
      if (show) {
        modalsOpen.current += 1;

        if (modalRef !== null && modalRef !== void 0 && modalRef.current && !props.disabledScrollBlock) {
          (0, _bodyScrollLock.disableBodyScroll)(modalRef.current);
        }
      } else {
        modalsOpen.current -= 1;
        allowClose.current = true;

        if (modalRef !== null && modalRef !== void 0 && modalRef.current && !props.disabledScrollBlock) {
          (0, _bodyScrollLock.enableBodyScroll)(modalRef.current);
        }

        if (!modalsOpen.current && !props.disabledScrollBlock) {
          (0, _bodyScrollLock.clearAllBodyScrollLocks)();
        }
      }

      if (onToggle) {
        onToggle(show);
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [show, preShow, prevShow, prevPreShow]);
  (0, _react.useEffect)(function () {
    if (modalRef !== null && modalRef !== void 0 && modalRef.current) {
      if (prevShow && !show) {
        (0, _bodyScrollLock.enableBodyScroll)(modalRef.current);
        window.document.body.removeAttribute('data-modal-open');
      }
    }
  }, [show, modalRef, prevShow]);
  var toggleFromBackground = (0, _react.useCallback)(function () {
    if (props.disableBackgroundClose) {
      return;
    }

    toggle();
  }, [props.disableBackgroundClose, toggle]);
  var unallowClose = (0, _react.useCallback)(function () {
    if (props.disableBackgroundClose) {
      return;
    }

    allowClose.current = false;
  }, [props.disableBackgroundClose]);
  return /*#__PURE__*/_react["default"].createElement(_Portal.Portal, {
    id: "modal"
  }, preShow ? /*#__PURE__*/_react["default"].createElement("div", {
    id: "modal-backdrop",
    className: (0, _scss.cls)(_stylesModule["default"]['modal-backdrop'], _stylesModule["default"]['backdrop-fade-opacity'], show && _stylesModule["default"]['show'])
  }) : null, /*#__PURE__*/_react["default"].createElement("div", {
    ref: modalRef,
    id: "modal-content",
    className: (0, _scss.cls)(_stylesModule["default"]['modal'], _stylesModule["default"]['fade'], _stylesModule["default"]['fade-opacity'], classes['wrapper'], show && _stylesModule["default"]['show'], show && classes['show']),
    tabIndex: -1,
    onClick: toggleFromBackground,
    onKeyDown: toggleFromBackground,
    style: preShow ? {
      display: 'block'
    } : {},
    role: "dialog"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    onClick: unallowClose,
    onKeyDown: unallowClose,
    className: (0, _scss.cls)(_stylesModule["default"]['modal-dialog'], _stylesModule["default"]['modal-dialog-centered'], _stylesModule["default"]["modal-".concat(size ? size : 'lg')], classes['dialog']),
    role: "document"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _scss.cls)(_stylesModule["default"]['modal-content'], classes['content'])
  }, header ? /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _scss.cls)(_stylesModule["default"]['modal-header'], classes['header'])
  }, header, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    "data-dismiss": "modal",
    onClick: toggle,
    "aria-label": "Close",
    className: (0, _scss.cls)(classes['closeButton'])
  }, /*#__PURE__*/_react["default"].createElement("span", null, "\xD7"))) : null, children ? /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _scss.cls)(_stylesModule["default"]['modal-body'], classes['body'])
  }, children) : null, footer ? /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _scss.cls)(_stylesModule["default"]['modal-footer'], _stylesModule["default"]['justify-content-center'], classes['footer'])
  }, footer) : null))));
});
var _default = Modal;
exports["default"] = _default;